import { Box, Button, Stack, Typography } from "@mui/material";
import { WeekDay } from "Types/WeekDay";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.Facilities.Form.OpeningHours;

const ALL_DAYS = Object.values(WeekDay);
const WEEKEND = [WeekDay.Saturday, WeekDay.Sunday];
const WEEKDAYS = [
  WeekDay.Monday,
  WeekDay.Tuesday,
  WeekDay.Wednesday,
  WeekDay.Thursday,
  WeekDay.Friday,
];

const OPTIONS = [
  { translationKey: "AllWeek" as const, value: ALL_DAYS },
  { translationKey: "Weekdays" as const, value: WEEKDAYS },
  { translationKey: "Weekend" as const, value: WEEKEND },
];

type Props = { onSelect: (days: Array<WeekDay>) => void };

export const QuickSelectButtons = ({ onSelect }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2" fontSize={["0.875rem", "1rem"]}>
        {t(RESOURCES.QuickSelectTitle)}
      </Typography>
      <Box
        mb={3}
        gap={1}
        display="flex"
        flexWrap="wrap"
        sx={{ "& > button": { minWidth: ["fit-content", "auto"] } }}
      >
        {OPTIONS.map(({ translationKey, value }) => (
          <Button
            key={translationKey}
            size="small"
            onClick={() => onSelect(value)}
            variant="outlined"
          >
            {t(RESOURCES.QuickSelect[translationKey])}
          </Button>
        ))}
      </Box>
    </Stack>
  );
};
